import React from 'react'

const NotFound = () => (
    <div className="container">
      <h1>Hmm....</h1>
      <p className="lead">
        This page doesn't seem to exist... Or does it?  Cause here we are. So it must exist. But really, it doesn't.
      </p>
      <a href="/">Take Me Home!</a>
    </div>
);

export default NotFound;
